module.exports = __webpack_public_path__ + "static/pfagoraslabpro-medium.ec250065.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/pfagoraslabpro-medium.ttf
// module id = 324
// module chunks = 114276838955818